"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownButton = void 0;
exports.DropdownMenu = DropdownMenu;
exports.StyledMenu = exports.DropdownWrapper = exports.DropdownMenuItem = void 0;

var _reactAriaMenubutton = require("react-aria-menubutton");

var _styles = require("react-components/styles");

var _styledTools = require("styled-tools");

var _dom = require("@slyk/dom");

var _typographyStyles = require("./typography/typography-styles");

var _react = _interopRequireWildcard(require("react"));

var _routerLink = _interopRequireDefault(require("./links/router-link"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Export `DropdownWrapper` styled component.
 */
var DropdownWrapper = (0, _styledComponents["default"])(_reactAriaMenubutton.Wrapper).withConfig({
  displayName: "dropdown-menu__DropdownWrapper",
  componentId: "sc-6tlofy-0"
})(["position:relative;"]);
/**
 * Export `DropdownButton` styled component.
 */

exports.DropdownWrapper = DropdownWrapper;
var DropdownButton = (0, _styledComponents["default"])(_reactAriaMenubutton.Button).withConfig({
  displayName: "dropdown-menu__DropdownButton",
  componentId: "sc-6tlofy-1"
})(["align-items:center;border-radius:", "px;cursor:pointer;display:flex;justify-content:center;outline-width:0;position:relative;transition:", ";transition-property:background-color,color;z-index:", ";", " ", " &:focus-visible{outline-width:4px;}&:-moz-focusring{outline-width:1px;}&:disabled{pointer-events:none;}"], (0, _styledTools.theme)('dimensions.borderRadius'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.theme)('zIndex.dropdown.button'), (0, _styledTools.switchProp)('colorTheme', {
  primary: (0, _styledComponents.css)(["background-color:", ";color:", ";&:focus,&:hover{background-color:", ";}"], (0, _styles.color)('blue200'), (0, _styles.color)('blue500'), (0, _styles.color)('blue400')),
  secondary: (0, _styledComponents.css)(["background-color:", ";color:", ";&:focus,&:hover{background-color:", ";}&:disabled{background-color:", ";color:", ";}"], (0, _styles.color)('gray300'), (0, _styles.color)('gray500'), (0, _styles.color)('gray400'), (0, _styles.color)('gray200'), (0, _styles.color)('gray400')),
  transparent: (0, _styledComponents.css)(["background-color:transparent;color:", ";&:focus,&:hover{color:", ";}"], (0, _styles.color)('gray500'), (0, _styles.color)('blue500'))
}), (0, _styledTools.switchProp)('size', {
  large: (0, _styledComponents.css)(["height:36px;width:36px;"]),
  medium: (0, _styledComponents.css)(["height:32px;width:32px;"]),
  small: (0, _styledComponents.css)(["height:24px;width:24px;"])
}, (0, _styledComponents.css)(["height:", ";width:", ";"], (0, _styledTools.prop)('size'), (0, _styledTools.prop)('size'))));
/**
 * Export `StyledMenu` styled component.
 */

exports.DropdownButton = DropdownButton;
var StyledMenu = (0, _styledComponents["default"])(_reactAriaMenubutton.Menu).withConfig({
  displayName: "dropdown-menu__StyledMenu",
  componentId: "sc-6tlofy-2"
})(["background-color:", ";border:1px solid ", ";border-radius:", "px;max-height:70vh;min-width:100%;overflow:auto;padding:0;position:absolute;top:", ";z-index:", ";", ""], (0, _styles.color)('white'), (0, _styles.color)('gray300'), (0, _styledTools.theme)('dimensions.borderRadius'), (0, _styledTools.prop)('top', 0), (0, _styledTools.theme)('zIndex.dropdown.menu'), (0, _styledTools.switchProp)('align', {
  left: 'left: 0;',
  right: 'right: 0;'
}));
/**
 * Export `DropdownMenuItem` styled component.
 */

exports.StyledMenu = StyledMenu;
var DropdownMenuItem = (0, _styledComponents["default"])(_reactAriaMenubutton.MenuItem).attrs(function (_ref) {
  var disabled = _ref.disabled,
      href = _ref.href,
      to = _ref.to;
  return {
    'aria-disabled': disabled,
    tag: to && _routerLink["default"] || href && 'a' || 'div'
  };
}).withConfig({
  displayName: "dropdown-menu__DropdownMenuItem",
  componentId: "sc-6tlofy-3"
})(["", " appearance:none;background-color:transparent;border:0;color:", ";cursor:pointer;display:block;margin:0;padding:12px 16px;text-align:left;transition:", ";transition-property:background-color,color;white-space:nowrap;", " ", " ", " ", ""], _typographyStyles.typography.styles.textNormal, (0, _styles.color)('secondary'), (0, _styledTools.theme)('animations.defaultTransition'), (0, _styledTools.ifProp)('disabled', (0, _styledComponents.css)(["cursor:default;opacity:0.5;pointer-events:none;"])), (0, _styledTools.ifProp)('isActive', (0, _styledComponents.css)(["color:", ";pointer-events:none;"], (0, _styles.color)('blue500'))), _styles.states.action(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    text-decoration: none;\n  "]))), _styles.states.interaction(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    color: ", ";\n  "])), (0, _styles.color)('info100'), (0, _styles.color)('blue500')));
/**
 * Export `DropdownMenu` component.
 */

exports.DropdownMenuItem = DropdownMenuItem;

function DropdownMenu(props) {
  var alignDropdown = props.alignDropdown,
      children = props.children,
      className = props.className,
      colorTheme = props.colorTheme,
      isDisabled = props.isDisabled,
      label = props.label,
      menuTopPosition = props.menuTopPosition,
      onMenuToggle = props.onMenuToggle,
      onSelection = props.onSelection,
      size = props.size;
  var onMenuToggleRef = (0, _react.useRef)();
  var onSelectionRef = (0, _react.useRef)();
  onMenuToggleRef.current = onMenuToggle;
  onSelectionRef.current = onSelection;
  return /*#__PURE__*/_react["default"].createElement(DropdownWrapper, {
    className: className,
    onMenuToggle: function onMenuToggle(_ref2) {
      var isOpen = _ref2.isOpen;

      if (onMenuToggleRef.current) {
        onMenuToggleRef.current(isOpen);
      }
    },
    onSelection: function onSelection(value, event) {
      (0, _dom.stopPropagation)(event);

      if (onSelectionRef.current) {
        onSelectionRef.current(value);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(DropdownButton, {
    colorTheme: colorTheme,
    disabled: isDisabled,
    size: size
  }, label), /*#__PURE__*/_react["default"].createElement(StyledMenu, {
    align: alignDropdown,
    top: menuTopPosition
  }, children));
}